<template>
  <div class="top-nav">
    <div class="logo">
      <router-link to="/"><img src="./LOGO.png" alt="爱旅拍文旅集团"></router-link>
    </div>
    <ul class="left-nav">
      <template v-for="(item,index) in navList">
        <li v-if="!item.hidden" :key="index" :class="(index==defaultCur)?'cur':''" @click="tagView(index, item.alias)">
          <i v-if="item.alias == 'product_management'" class="el-icon-menu" />
          <i v-if="item.alias == 'order_management'" class="el-icon-s-claim" />
          <i v-if="item.alias == 'refund_management'" class="el-icon-s-release" />
          <i v-if="item.alias == 'system_management'" class="el-icon-s-tools" />
          <!-- <i v-if="item.alias == 'stats_management'" icon-class="chart" /> -->
          <svg-icon v-if="item.alias == 'stats_management'" icon-class="chart" />
          {{ item.name }}
        </li>
      </template>
    </ul>
    <div class="right-user">
      <a href="javascript:;" onclick="location.reload();"><img class="refresh" src="./refresh.png" alt="刷新"></a>
      <!--<div>中文</div>-->
      <lang-select />
      <el-dropdown trigger="click">
        <div class="user">
          <el-badge :value="unreadNo" :max="9" :hidden="unreadNo == 0 ? true : false" class="item">
            <img v-if="avatar" class="userImg" :src="avatar" alt="头像">
            <img v-else class="userImg" src="./user.png" alt="头像">
          </el-badge>
          {{ name }}
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- 个人中心 -->
          <router-link to="/profile/index">
            <el-dropdown-item>
              {{ $t('navbar.profile') }}
            </el-dropdown-item>
          </router-link>
          <!-- 消息中心 -->
          <router-link to="/message">
            <el-dropdown-item>
              <el-badge is-dot :hidden="unreadNo == 0 ? true : false" class="item">
                {{ $t('route.message') }}
              </el-badge>
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 新订单提示音 -->
    <video id="order_video" src="./newMessage.mp3" :hidden="true" />
    <!-- 解决Chrome 声音自动播放抱错问题 -->
    <!-- <div v-if="autoPlay" class="autoPlay" @click="playF" /> -->
    <!-- 新订单通知 -->
    <!-- <el-button plain @click="unread">
      获取未读订单
    </el-button> -->

    <!-- 订单详情(车队) -->
    <uDetialDialog v-if="dialogVisible" :visible="dialogVisible" :orderid="order_id" :btn-per="btnPer" @cancelBut="dialogVisible = false" @fresh="fresh" />
    <!-- 订单详情(酒店) -->
    <uDetialDialog2 v-if="dialogVisible2" :visible="dialogVisible2" :orderid="order_id" :btn-per="btnPer" @cancelBut="dialogVisible2 = false" />
    <!-- 保养录入弹窗 -->
    <maintainDialog v-if="detialVisible" :visible="detialVisible" :orderid="order_id" @cancelBut="detialVisible = false" @fresh="fresh" />
  </div>
</template>

<script>
import {
  setRoles,
  getTopNavs,
  getAllRoles,
  setDefaultCur,
  getDefaultCur,
  setTopdefaultCur,
  getRoleId,
  getNickname,
  getAvatar,
  getPermission,
  setRouterArr,
  getAllPermission
} from '@/utils/auth' // getTopdefaultCur
import { resetRouter } from '@/router'
import { transRouteData } from '@/store/modules/user'
// import { getDetailAdminUser } from '@/api/users'
import { unread, getRing, getMessageList, read } from '@/api/user'
import { mapGetters } from 'vuex'
import LangSelect from '@/components/LangSelect'
import uDetialDialog from '@/views/order/car/components/detailDialog' // 订单详情(车队)
import uDetialDialog2 from '@/views/order/hotel/components/detailDialog' // 订单详情(酒店)
import maintainDialog from '@/views/order/car/components/maintainDialog' // 保养录入弹窗

export default {
  components: {
    LangSelect,
    uDetialDialog,
    uDetialDialog2,
    maintainDialog
  },
  data() {
    return {
      navList: [],
      allRoles: [],
      defaultCur: getDefaultCur() || 0,
      // avatar: '',
      // nickname: '',
      message: {
        newmessage: 0, // 是否有新的消息
        time: parseInt(new Date().getTime() / 1000)
      },
      interval: null, // 计时器
      order_video: undefined, // 播放器
      dialogVisible: false, // 详情弹出(车队)
      dialogVisible2: false, // 详情弹出(酒店)
      detialVisible: false, // 详情显示状态(车辆保养)
      instances: {}, // 通知Id
      messageId: 0,
      // autoPlay: false,
      listQuery: {
        page: {
          page: 1,
          limit: 30
        },
        filter: {
          status: undefined
        }
      },
      list: [], // 消息列表
      order_id: undefined, // 消息订单id
      routerArr: []
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'device', 'unreadNo', 'is_turnring', 'btnPer', 'name', 'avatar']),
    lang() {
      return this.$store.getters.language
    }
  },
  watch: {
    $route(to) {},
    lang() {
      // let _navList = []
      // this.navList.forEach((item, index) => {
      //   _navList[index] = {
      //     alias: item.alias,
      //     current: item.alias === this.defaultCur,
      //     name: this.$t('navbar.' + item.alias)
      //   }
      // })
      // this.navList = _navList
    }
  },
  created() {
    // getDetailAdminUser({}).then(res => {
    //   if (res.data.avatar) {
    //     this.avatar = process.env.VUE_APP_BASE_API + res.data.avatar
    //   }
    //   this.nickname = res.data.nickname || ''
    // })

    if (getTopNavs()) {
      // this.routerArr = getRouterArr()[getDefaultCur()].router
      // console.log(this.routerArr)
      // this.$store
      //   .dispatch('permission/autoGenerateRoutes', this.routerArr, { root: true })
      //   .then(() => {
      //     this.$store.dispatch('tagsView/delAllViews', null, { root: true })
      //   })

      this.navList = JSON.parse(getTopNavs())
      this.allRoles = JSON.parse(getAllRoles())
      this.defaultCur = getDefaultCur()
    }
    // 获取是否接收提示音
    this.getRing()
    // 获取未读消息数量
    this.unread()
    // 获取页面按钮权限
    this.setBtnPer()
  },
  /** 卸载监听 */
  destroyed() {
    // window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    /**
     * 退出登录
     */
    logout() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push(`/login?redirect=dashboard`)
        loading.close()
      })
    },

    /**
     * 点击切换
     */
    async tagView(index, item) {
      if (index !== this.defaultCur) {
        this.defaultCur = index
        var roles = this.allRoles[index]
        // console.log(roles)
        setRoles(roles)
        this.$set(this.navList[index], 'current', true)
        this.$set(this.navList[this.defaultCur], 'current', false)
        setDefaultCur(index)
        setTopdefaultCur(item)

        // 生成新路由
        resetRouter()
        const accessRoutes = await transRouteData(getAllPermission()[index].router)
        const newAccessRoutes = await this.$store.dispatch(
          'permission/autoGenerateRoutes',
          accessRoutes,
          { root: true }
        )
        this.$router.addRoutes(newAccessRoutes)
        setRouterArr(newAccessRoutes)
        this.$store.dispatch('tagsView/delAllViews', null, { root: true })
        this.$router.push(
          `/?fresh=${new Date().toLocaleString() + (Math.random() * 10).toFixed(0)}`
        )
      }
    },

    /** 未读消息数量 */
    unread() {
      let that = this
      var i = 0
      // var abc = 0
      start()
      function start() {
        // 启动计时器函数
        if (that.interval != null) {
          // 判断计时器是否为空
          clearInterval(that.interval)
          that.interval = null
        }
        getUnread()
        that.interval = setInterval(getUnread, 60000) // 启动计时器，调用getUnread函数，
      }

      function getUnread() {
        // console.log(abc++)
        let data = {
          data: {
            time: that.message.time
          }
        }
        // console.log(555)
        unread(data)
          .then(res => {
            that.message = { ...res.data }
            that.message.time = parseInt(new Date().getTime() / 1000)
            that.$store.dispatch('message/changeUnReadNo', res.data.unread_no)
            // 有新消息时
            if (res.data.newmessage > 0) {
              // 当前为消息列表页时,刷新页面
              if (that.$route.path == '/message') {
                getRing({}).then(res => {
                  // 获取最新的是否接收数据设置
                  this.$store.dispatch('message/getRing', res.data.is_turnring)
                  if (res.data.is_turnring == 1) {
                    const order_video = document.getElementById('order_video')
                    order_video.play()
                  }
                })
                setTimeout(() => {
                  location.reload()
                }, 1000)
              } else {
                // 获取最新消息
                that.getList(res.data.newmessage)
                // 接收提示音时
                if (that.is_turnring == 1) {
                  const order_video = document.getElementById('order_video')
                  order_video.play()
                  // console.log(666)
                }
              }
            }
          })
          .catch(() => {
            i++
          })
        if (i > 3) {
          stop()
        }
      }

      function stop() {
        clearInterval(that.interval)
        that.interval = null
      }
    },

    /** 获取列表数据 */
    getList(newmessage) {
      // console.log(88)
      let data = this.listQuery
      getMessageList(data).then(res => {
        this.list = [...res.data]
        // console.log(res.data)
        // 显示弹窗
        let that = this
        for (let i = 0; i < newmessage; i++) {
          showNotify(i)
        }
        function showNotify(i) {
          that.open1(
            res.data[i].title,
            res.data[i].detail,
            res.data[i].id,
            res.data[i].type,
            res.data[i].order_id
          )
        }
      })
    },

    // 通知
    open1(title, detail, id, type, order_id) {
      let messageId = this.messageId
      this.messageId = messageId + 1
      const h = this.$createElement
      this.instances[messageId] = this.$notify({
        title: title,
        message: h('a', { style: 'color: teal' }, detail),
        duration: 0, // 不自动关闭
        position: 'bottom-right', // 右下角
        onClick: () => {
          // console.log('id:', id, 'type', type)
          // console.log(type)
          this.close(this.instances[messageId])
          this.order_id = order_id
          switch (type) {
            case 1:
              this.dialogVisible = true
              break
            case 2:
              this.dialogVisible = true
              break
            case 3:
              this.dialogVisible2 = true
              break
            case 4:
              this.detialVisible = true
              break
          }

          // 更新已读
          let data = {
            data: { id: id }
          }
          read(data).then(() => {
            this.$store.dispatch('message/changeUnReadNo', this.unreadNo - 1)
          })
        }
      })
    },

    /** 关闭指定通知 */
    close(instance) {
      instance.close()
    },

    /** 获取页面按钮权限 */
    setBtnPer() {
      let p = getPermission()
      let btnPer = {}
      for (var i in p) {
        p[i].forEach(item => {
          if (item.indexOf('|') > -1) {
            let arr = item.split('|')
            arr.forEach(ite => {
              btnPer[ite] = true
            })
          } else {
            btnPer[item] = true
          }
        })
      }
      this.$store.dispatch('message/setBtnPer', btnPer)
      // 获取是否为管理员
      // 保存角色基本信息
      // console.log(8765)
      if (!this.name) {
        let info = {
          roleId: getRoleId(),
          name: getNickname(),
          avatar: getAvatar()
        }
        // console.log(info)
        this.$store.dispatch('user/getInfo', info)
      }
      //
    },

    /** 获取页面自动播放设置 */
    getRing() {
      getRing({}).then(res => {
        this.$store.dispatch('message/getRing', res.data.is_turnring)
        // Chrome 声音自动播放抱错问题
        // if (res.data.is_turnring == 1) {
        // this.autoPlay = true
        // this.playF()
        // }
      })
    },
    playF() {
      // this.autoPlay = false
      const order_video = document.getElementById('order_video')
      order_video.play()
      setTimeout(() => {
        order_video.pause()
      }, 10)
    },
    fresh() {}
  }
}
</script>

<style lang="scss">
.top-nav {
  // background: #32b5cb;
  background: linear-gradient(90deg, #32b5cb 0%, #34a8ca 62%, #3694cb 100%);
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  z-index: 1001;
  color: #fff;
  $border: 1px solid rgba(255, 255, 255, 0.4);
  .logo {
    border-right: $border;
    height: 70px;
    img {
      height: 30px;
      margin: 20px 27px;
      display: block;
    }
  }
  .left-nav {
    display: flex;
    margin-right: auto;
    font-size: 0.9em;
    font-weight: 300;
    align-self: stretch;
    & > * {
      list-style: none;
      padding: 0 1em;
      border-right: $border;
      display: flex;
      align-items: center;
      text-align: center;
      cursor: pointer;
      // &:hover {
      //   background: rgba(255, 255, 255, 0.8);
      //   cursor: pointer;
      //   color: #35adca;
      //   box-shadow: 0 2px 5px;
      //   font-weight: 400;
      // }
      &.cur,
      &:hover {
        // &:hover {
        //   color: #fff;
        //   background: rgba(0, 0, 50, 0.1);
        //   box-shadow: none;
        //   font-weight: 300;
        // }
        background: rgba(0, 0, 50, 0.1);
        cursor: pointer;
      }
    }
    i,
    svg {
      margin-right: 5px;
    }
    svg {
      font-size: 0.9em;
    }
  }
  .right-user {
    display: flex;
    & > * {
      padding: 0 1em;
      display: flex;
      align-items: center;
      & + * {
        border-left: $border;
      }
    }
    .refresh {
      height: 20px;
    }
    .user {
      display: flex;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
      .userImg {
        border-radius: 50%;
        width: 32px;
        height: 32px;
        margin-right: 0.5em;
        overflow: hidden;
        flex-shrink: 0;
      }
    }
    .el-dropdown {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
    .el-badge {
      padding-right: 0.5em;
      .el-badge__content.is-fixed {
        border: none;
        right: 25px;
      }
    }
  }
}
.el-badge__content.is-fixed.is-dot {
  right: 0px;
  top: 5px;
}
.autoPlay {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(255, 255, 255, 0.01);
  z-index: 2000;
}
</style>
